export const planes = [
  {
    nombre: "Essential",
    precio: "$2.000.000",
    horas: "4 a 6 horas mensuales",
    destacado: false,
    descripcion:
      "Dirigido a empresas que requieren visibilidad financiera básica y seguimiento periódico de sus resultados.",
    incluye: [
      "Dashboard financiero mensual.",
      "Seguimiento de ingresos, costos y márgenes.",
      "Monitoreo básico de flujo de caja.",
      "Reunión mensual de seguimiento.",
      "Informe ejecutivo con hallazgos y recomendaciones.",
    ],
  },
  {
    nombre: "Growth",
    precio: "$3.500.000",
    horas: "8 a 12 horas mensuales",
    destacado: true,
    descripcion:
      "Dirigido a empresas en crecimiento que necesitan planeación financiera y control permanente del negocio.",
    incluye: [
      "Todo lo del Plan Essential.",
      "Modelo financiero.",
      "Forecast de ingresos y gastos.",
      "Planeación de caja.",
      "Seguimiento de indicadores estratégicos.",
      "Análisis periódico de rentabilidad.",
      "Dos reuniones mensuales.",
    ],
  },
  {
    nombre: "Strategic",
    precio: "$6.000.000",
    horas: "16 a 24 horas mensuales",
    destacado: false,
    descripcion:
      "Dirigido a empresas que requieren acompañamiento financiero de alto nivel para crecimiento, expansión o búsqueda de financiación.",
    incluye: [
      "Todo lo del Plan Growth.",
      "Evaluación financiera de nuevos proyectos.",
      "Análisis de expansión.",
      "Apoyo en procesos de financiación.",
      "Preparación de información para inversionistas.",
      "Participación en reuniones estratégicas.",
      "Disponibilidad prioritaria.",
    ],
  },
];

export const comparativoPlanes = [
  { caracteristica: "Inversión mensual", essential: "COP $2.000.000", growth: "COP $3.500.000", strategic: "COP $6.000.000" },
  { caracteristica: "Reuniones de seguimiento", essential: "1 mensual", growth: "2 mensuales", strategic: "Semanales" },
  { caracteristica: "Dashboard financiero", essential: "check", growth: "check", strategic: "check" },
  { caracteristica: "Seguimiento de ingresos y gastos", essential: "check", growth: "check", strategic: "check" },
  { caracteristica: "Seguimiento de márgenes", essential: "check", growth: "check", strategic: "check" },
  { caracteristica: "Flujo de caja", essential: "Básico", growth: "Avanzado", strategic: "Avanzado" },
  { caracteristica: "Forecast financiero", essential: "dash", growth: "check", strategic: "check" },
  { caracteristica: "Modelo financiero", essential: "dash", growth: "check", strategic: "check" },
  { caracteristica: "KPIs estratégicos", essential: "dash", growth: "check", strategic: "check" },
  { caracteristica: "Análisis de rentabilidad", essential: "dash", growth: "check", strategic: "check" },
  { caracteristica: "Evaluación de proyectos", essential: "dash", growth: "dash", strategic: "check" },
  { caracteristica: "Análisis de expansión", essential: "dash", growth: "dash", strategic: "check" },
  { caracteristica: "Apoyo en financiación", essential: "dash", growth: "dash", strategic: "check" },
  { caracteristica: "Presentaciones para inversionistas", essential: "dash", growth: "dash", strategic: "check" },
  { caracteristica: "Soporte por correo y WhatsApp", essential: "check", growth: "check", strategic: "Prioritario" },
];

export const exclusiones = [
  "Contabilidad.",
  "Elaboración de declaraciones tributarias.",
  "Revisoría fiscal.",
  "Auditoría.",
  "Nómina.",
  "Servicios jurídicos.",
  "Implementación de software contable.",
  "Gestión operativa de cartera.",
  "Registro de transacciones contables.",
];

export const serviciosEspecializadosIntro =
  "Además de la dirección de innovación financiera, ofrecemos proyectos financieros y estratégicos de alcance específico que pueden contratarse de manera independiente o complementaria. A través de la alianza con Open Options, también puede activar consultoría en estrategia, comercial y talento humano.";

export const serviciosAdicionales = [
  {
    servicio: "Valoración de empresas",
    descripcion: "Estimación del valor económico de una compañía mediante metodologías financieras.",
    entregables: [
      "1 Excel — Modelo de valoración (DCF, comparables y sensibilidad).",
      "1 PDF — Informe ejecutivo de valoración (15–25 páginas).",
      "1 PowerPoint — Resumen para junta directiva (10–12 diapositivas).",
    ],
    inversion: "Desde COP $2.000.000",
  },
  {
    servicio: "Modelación financiera especializada",
    descripcion: "Construcción de modelos financieros para planeación, inversión o evaluación de escenarios.",
    entregables: [
      "1–2 Excel — Modelo financiero estructurado con escenarios base, optimista y estrés.",
      "1 PDF — Nota metodológica, supuestos y limitaciones (5–8 páginas).",
      "1 PowerPoint — Resumen de escenarios y conclusiones (8–10 diapositivas).",
    ],
    inversion: "Desde COP $1.500.000",
  },
  {
    servicio: "Business Plan",
    descripcion: "Elaboración de proyecciones financieras y documento de soporte para crecimiento o financiación.",
    entregables: [
      "1 Word / PDF — Documento Business Plan (25–40 páginas).",
      "1 Excel — Proyecciones financieras a 3–5 años (P&L, caja, balance).",
      "1 PowerPoint — Pitch deck para bancos o aliados (12–15 diapositivas).",
    ],
    inversion: "Desde COP $2.500.000",
  },
  {
    servicio: "Preparación para levantamiento de capital",
    descripcion: "Estructuración financiera, métricas e información para inversionistas.",
    entregables: [
      "1 Excel — Modelo financiero y métricas para data room.",
      "1 PowerPoint — Deck para inversionistas (15–20 diapositivas).",
      "1 PDF — One-pager + memo de estructura de capital (10–15 páginas).",
      "1 Word — Guía de Q&A y checklist de due diligence.",
    ],
    inversion: "Desde COP $3.000.000",
  },
  {
    servicio: "Due Diligence Financiero",
    descripcion: "Revisión y análisis financiero para procesos de inversión o adquisición.",
    entregables: [
      "1 Excel — Hallazgos, ajustes y estados normalizados.",
      "1 PDF — Informe de due diligence financiero (20–35 páginas).",
      "1 PowerPoint — Resumen ejecutivo para comité de inversión (8–10 diapositivas).",
    ],
    inversion: "Desde COP $4.000.000",
  },
  {
    servicio: "Estudios de mercado",
    descripcion: "Investigación sectorial, análisis competitivo y evaluación de oportunidades.",
    entregables: [
      "1 PDF — Informe de mercado y competencia (15–25 páginas).",
      "1 Excel — Datos sectoriales, benchmarks y tablas de soporte.",
      "1 PowerPoint — Conclusiones y oportunidades (10 diapositivas).",
    ],
    inversion: "Desde COP $2.000.000",
  },
  {
    servicio: "Evaluación financiera de adquisiciones",
    descripcion: "Análisis financiero y estratégico de potenciales adquisiciones o inversiones.",
    entregables: [
      "1 Excel — Modelo de adquisición, sinergias y retorno.",
      "1 PDF — Memo de recomendación go / no-go (12–18 páginas).",
      "1 PowerPoint — Resumen para decisión de directorio (8–12 diapositivas).",
    ],
    inversion: "Desde COP $3.500.000",
  },
  {
    servicio: "Diseño de indicadores gerenciales",
    descripcion: "Construcción de KPIs y dashboards para seguimiento del negocio.",
    entregables: [
      "1 Excel — Dashboard de KPIs con fórmulas y segmentación acordada.",
      "1 PDF — Diccionario de indicadores y metodología (8–12 páginas).",
      "1 PowerPoint — Presentación del tablero a gerencia (6–8 diapositivas).",
    ],
    inversion: "Desde COP $1.000.000",
  },
  {
    servicio: "Coberturas financieras",
    descripcion:
      "Diseño y acompañamiento en estrategias de cobertura para mitigar riesgos de tipo de cambio, tasas de interés u otros factores que afectan la operación o los resultados de la empresa.",
    entregables: [
      "1 Excel — Modelo de exposición y escenarios de cobertura.",
      "1 PDF — Memo de estrategia e instrumentos recomendados (8–15 páginas).",
      "1 PowerPoint — Propuesta para comité de riesgos (6–10 diapositivas).",
      "Alcance y cantidad de entregables personalizados según complejidad.",
    ],
    inversion: "Personalizadas",
  },
  {
    servicio: "Gestión de portafolios",
    descripcion:
      "Gestión de portafolios con estrategias acorde a ciclos económicos y del negocio. Gestionamos cuentas empresariales vía tercerización, sin incurrir en procesos de captación de fondos, mediante cuentas de gestión patrimonial con entidades reguladas para dicho fin.",
    entregables: [
      "1 PDF — Política de inversión y perfil de riesgo acordado.",
      "1 Excel — Reporte mensual de composición y rendimiento.",
      "1 PowerPoint — Revisión trimestral de portafolio (8–12 diapositivas).",
      "Reportes PDF periódicos emitidos por la entidad regulada (según contrato).",
    ],
    inversion: "Desde COP $150.000.000",
  },
];

export const serviciosEspecializadosNota =
  "Los valores y cantidades de entregables son de referencia por proyecto. El alcance, complejidad, disponibilidad de información y tamaño de la empresa pueden modificar la cotización y el número de archivos (Excel, PDF, PowerPoint o Word) incluidos.";

export const condicionesGenerales = [
  "Facturación mensual anticipada.",
  "Contrato de prestación de servicios.",
  "Permanencia mínima sugerida de tres (3) meses.",
  "Toda la información suministrada por la empresa será tratada de manera confidencial.",
];

export const WHATSAPP_CFO =
  "https://wa.me/573213213635?text=Hola%2C%20me%20interesa%20solicitar%20asesor%C3%ADa%20sobre%20el%20servicio%20de%20CFO%20Fraccional.";

export const buildWhatsAppEmpresasContactUrl = ({ name, email, phone, pageUrl }) => {
  const text = [
    "Hola, vengo desde la sección Empresas de MEU Aliado.",
    `Nombre: ${name}`,
    `Correo: ${email}`,
    `Teléfono: ${phone}`,
    pageUrl ? `Página: ${pageUrl}` : null,
    "Me gustaría explorar soluciones para mi empresa sin compromiso.",
  ]
    .filter(Boolean)
    .join("\n");

  return `https://wa.me/573213213635?text=${encodeURIComponent(text)}`;
};

export const WHATSAPP_CFO_SERVICIOS_SOLICITUD =
  "https://wa.me/573213213635?text=Hola%2C%20me%20interesa%20solicitar%20un%20servicio%20que%20no%20est%C3%A1%20incluido%20en%20los%20planes%20de%20CFO%20Fraccional.%20%C2%BFPodemos%20conversar%3F";

export const WHATSAPP_CFO_SERVICIOS_ESPECIALIZADOS =
  "https://wa.me/573213213635?text=Hola%2C%20me%20interesa%20solicitar%20asesor%C3%ADa%20sobre%20un%20servicio%20especializado%20de%20CFO%20Fraccional.%20%C2%BFPodemos%20conversar%3F";

export const LINKEDIN_JULIAN = "https://www.linkedin.com/in/julian-herrera-09b361231/";
